import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import ForgotPasswordForm from './ForgotPasswordForm'

export default function ForgotPassword() {
    return (
        <Container className="p-0" fluid>
            <Row className="m-0">
                <Col xs={12} className="p-0">
                    <div className="login-card login-dark">
                        <ForgotPasswordForm />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}